import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=fd6dfbee&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=ts&"
export * from "./Price.vue?vue&type=script&lang=ts&"
import style0 from "./Price.vue?vue&type=style&index=0&id=fd6dfbee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6dfbee",
  null
  
)

export default component.exports